module.exports = __webpack_public_path__ + "img/times-circle-solid.59fdef85.svg";